import React from 'react';
import InternalImage from '../internal-image';
function getUrl(url) {
    if (!url.match(/^[a-zA-Z]+:\/\//)) {
        url = 'http://' + url;
    }
    return url;
}
export default function PartnerDisplay(props) {
    const {partner} = props;
    return (
        <div className="partner">
            {partner.link
                ? <a href={getUrl(partner.link)} target="_blank">
                        <InternalImage id={partner.imageId}></InternalImage>
                    </a>
                : <InternalImage id={partner.imageId}></InternalImage>}

        </div>
    )
}



// WEBPACK FOOTER //
// ./src/js/components/partner/partner-display.js